// utils/recaptcha.js
export async function getRecaptchaToken(action = 'LOGIN', logger = console) {
  if (typeof grecaptcha === 'undefined') {
    logger.error('grecaptcha is not loaded');
    this.$toasted.global.error({message: 'reCAPTCHA is not available. Please try again later.'});
    return null;
  }

  try {
    await new Promise((resolve) => grecaptcha.enterprise.ready(resolve));
    logger.info('trying to get captcha token');
    const token = await grecaptcha.enterprise.execute('6LeCnlUrAAAAALiPVVBmKpCsXII6AgJxXXrvlLBK', { action });
    return token;
  } catch (e) {
    logger.error('grecaptcha.execute failed:', e);
    return null;
  }
}